(() => {
  const registry = new WeakMap();
  const initStickyHeaders = (scope = document) => {
    scope.querySelectorAll('.site-header').forEach((header) => {
      if (registry.has(header)) return;
      const spacer = document.createElement('div');
      spacer.className = 'pmw-sticky-header-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      header.before(spacer);
      let trigger = 0;
      let headerHeight = 0;
      let fixed = false;
      let scheduled = false;
      const measure = () => {
        if (fixed) {
          header.classList.remove('pmw-sticky-header--active');
          spacer.style.height = '0px';
        }
        trigger = header.getBoundingClientRect().top + window.scrollY;
        headerHeight = header.getBoundingClientRect().height;
        if (fixed) {
          header.classList.add('pmw-sticky-header--active');
          spacer.style.height = `${headerHeight}px`;
        }
      };
      const update = () => {
        scheduled = false;
        const shouldFix = window.scrollY > trigger;
        if (shouldFix === fixed) return;
        fixed = shouldFix;
        header.classList.toggle('pmw-sticky-header--active', fixed);
        spacer.style.height = fixed ? `${headerHeight}px` : '0px';
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      };
      measure();
      update();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', () => { measure(); update(); }, { passive: true });
      registry.set(header, { spacer });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initStickyHeaders());
  else initStickyHeaders();
  document.addEventListener('shopify:section:load', (event) => initStickyHeaders(event.target));
})();